/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B010080 受注確定
 */
import { Column, Query } from "@material-table/core";
import {
  B000140AssistantNm,
  B000151NonyuNm,
  B000150TokuiNm2,
  B000200JanshohinNm1,
  B000200ShohinNm,
  B010080Find,
  B010080FindRequest,
  B010080TogetsuYm,
  B010080Update,
  B010080UpdateRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SConfirmDialog,
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import {
  getSCode,
  JuchuKbnView,
  SCode,
  ShohinshubetsuKbnJuchuKakutei,
} from "messages/codes";
import { labels } from "messages/labels";
import {
  B000120,
  B000130,
  B000140,
  B000150,
  B000151,
  B000200,
  B000202,
} from "pages";
import { createRef, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { chunk, mapIds } from "services";
import { date, dateWithSlashAt } from "services/DateService";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  juchuYmdFrom: string;
  juchuYmdTo: string;
  shukayoteiYmdFrom: string;
  shukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  chumonNo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  assistantCd: string;
  assistantNm: string;
  janCd: string;
  janshohinNm: string;
  shohinCd: string;
  shohinNm: string;
  shohinshubetsuKbn: SCode;
}>;

// テーブルデータ定義
type Data = Partial<{
  gyoNo: string;
  juchuYmd: string;
  juchudenpyoNo: string;
  juchudenpyoNoF: string;
  juchuKbn: string;
  tokuiNm: string;
  shukayoteiYmd: string;
  meigyosu: string;
  juchuKin: string;
  biko: string;
  version: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  juchuYmdFrom: "",
  juchuYmdTo: date(), // 当日日付
  shukayoteiYmdFrom: "",
  shukayoteiYmdTo: "",
  eigyoCdFrom: "",
  eigyoCdTo: "",
  bumonCdFrom: "",
  bumonCdTo: "",
  shainCdFrom: "",
  shainCdTo: "",
  juchudenpyoNoFrom: "",
  juchudenpyoNoTo: "",
  chumonNo: "",
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNm: "",
  nonyuCd: "",
  nonyushitenCd: "",
  nonyuNm: "",
  shodaibun: "",
  shochubun: "",
  shoshobun: "",
  assistantCd: "",
  assistantNm: "",
  janCd: "",
  janshohinNm: "",
  shohinCd: "",
  shohinNm: "",
  shohinshubetsuKbn: getSCode(ShohinshubetsuKbnJuchuKakutei, "0"),
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行", width: "4rem" },
  {
    field: "juchuYmd",
    title: "受注日",
    width: "5rem",
    render: (data) => {
      if (data.juchuYmd! !== null && data.juchuYmd! !== "") {
        return dateWithSlashAt(data.juchuYmd!);
      }
    },
  },
  { field: "juchudenpyoNoF", title: "受注No", width: "5rem" },
  { field: "juchudenpyoNo", hidden: true },
  {
    field: "juchuKbn",
    title: "受注区分",
    width: "4rem",
    render: (data) => {
      return getSCode(JuchuKbnView, data.juchuKbn?.toString() ?? "0")?.label;
    },
  },
  { field: "tokuiNm", title: "得意先", width: "9rem" },
  {
    field: "shukayoteiYmd",
    title: "発送日",
    width: "5rem",
    render: (data) => {
      if (data.shukayoteiYmd! !== null && data.shukayoteiYmd! !== "") {
        return dateWithSlashAt(data.shukayoteiYmd!);
      }
    },
  },
  {
    field: "meigyosu",
    title: "明細数　",
    width: "3rem",
    align: "right",
  },
  {
    field: "juchuKin",
    title: "金額　",
    width: "5rem",
    align: "right",
    render: (data) => data.juchuKin?.toLocaleString(),
  },
  { field: "biko", title: "備考", width: "13rem" },
  { field: "version", hidden: true },
];

// フォーカスIDの設定
const focusId = "B010080";
// API通信分割のための分割数
const bunkatusu = 20;

export const B010080 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef();

  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);

  // 検索ボタン押下時に初期ページにするステート
  const isDefaultPage = useRef(false);

  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));

  // 画面遷移
  const navigate = useNavigate();

  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);

  // selectboxで選択された行のデータ
  const [selectedData, setSelectedData] = useState<Data[]>([]);

  // ボタンの活性・非活性
  const [disabledDecide, setDisabledDecide] = useState(true);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    // システムマスタの当月の初日
    (async () => {
      await B010080TogetsuYm(methods, navigate, setMsg);
      focus(1);
    })();
  }, []);

  // 検索時の初期化処理
  const handleResetSearch = () => {
    // ボタン非活性化
    setDisabledDecide(true);
    // 選択されているデータを空にする
    setSelectedData([]);
    (tableRef.current as any).handleClearSelect();
  };

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 初期化
    handleResetSearch();
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 検索パラメータを作成する。
      const param: B010080FindRequest = {
        juchuYmdFrom: fields.juchuYmdFrom,
        juchuYmdTo: fields.juchuYmdTo,
        shukayoteiYmdFrom: fields.shukayoteiYmdFrom,
        shukayoteiYmdTo: fields.shukayoteiYmdTo,
        eigyoCdFrom: fields.eigyoCdFrom,
        eigyoCdTo: fields.eigyoCdTo,
        bumonCdFrom: fields.bumonCdFrom,
        bumonCdTo: fields.bumonCdTo,
        shainCdFrom: fields.shainCdFrom,
        shainCdTo: fields.shainCdTo,
        juchudenpyoNoFrom: fields.juchudenpyoNoFrom,
        juchudenpyoNoTo: fields.juchudenpyoNoTo,
        chumonNo: fields.chumonNo,
        tokuiCd: fields.tokuiCd,
        tokuishitenCd: fields.tokuishitenCd,
        nonyuCd: fields.nonyuCd,
        nonyushitenCd: fields.nonyushitenCd,
        shodaibun: fields.shodaibun,
        shochubun: fields.shochubun,
        shoshobun: fields.shoshobun,
        assistantCd: fields.assistantCd,
        janCd: fields.janCd,
        shohinCd: fields.shohinCd,
        shohinshubetsuKbn: fields.shohinshubetsuKbn?.value,

        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        // ["出力項目名,順番(asc/desc", ...]
        sort: ["juchuYmd,asc", "tokuiCd,asc", "tokuishitenCd,asc"],
      };
      // API呼び出し
      B010080Find(param)
        // 正常取得時
        .then((value) => {
          const offset = query.pageSize * query.page;
          resolve({
            data: mapIds(value.data.content, "gyoNo", offset),
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  // テーブル行チェックボックス選択時
  const handleCheckTableRow = (data: Data[]) => {
    // 行が選択されている場合のみ実行する。
    const disabled = data.length <= 0;
    setDisabledDecide(disabled);
    setSelectedData(data);
  };
  // 確定イベント
  const handleDecide = () => {
    // API通信分割のため
    const chunked = chunk(
      selectedData.map((value) => {
        return { juchudenpyoNo: value.juchudenpyoNo, version: value.version };
      }),
      bunkatusu
    );
    (async () => {
      let r: any = undefined;
      for (const chunk of chunked) {
        if (r) break;

        // リクエスト作成
        const param: B010080UpdateRequest = {
          juchudenpyoNoList: chunk,
        };
        // API呼び出し
        await B010080Update(param).catch((reason) => {
          r = reason;
        });
      }

      // thenとcatchの内容
      // テーブル再検索
      (tableRef.current as any).onQueryChange();
      // ボタン非活性化
      setDisabledDecide(true);
      // 選択されているデータを空にする
      setSelectedData([]);
      if (r) {
        catchRestError(r, navigate, setMsg);
      } else {
        // 完了メッセージ
        setMsg(getClientMessage("B010080_001"));
      }
    })();
  };

  //商品中分類が入力されているかどうか
  const existShochubun: boolean = methods.watch("shochubun") !== "";
  //商品小分類が入力されているかどうか
  const existShoshobun: boolean = methods.watch("shoshobun") !== "";

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="受注確定"
        gridTemplateColumns="6rem 3rem 3rem 5rem 1rem 9rem 6rem 6rem 5rem 1rem 9rem"
      >
        <SLabel>受注日</SLabel>
        <SDateField name="juchuYmdFrom" {...register(1)} gridColumn="span 3" />
        <SText>～</SText>
        <SDateField name="juchuYmdTo" {...register(2)} />
        <SLabel>発送日</SLabel>
        <SDateField
          name="shukayoteiYmdFrom"
          {...register(16)}
          gridColumn="span 2"
        />
        <SText>～</SText>
        <SDateField name="shukayoteiYmdTo" {...register(17)} />
        <SLabel gridColumn="1">営業所</SLabel>
        <SNumberField
          name="eigyoCdFrom"
          code
          size={6}
          {...register(3)}
          gridColumn="span 3"
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCdFrom", data.eigyoCd);
          }}
        />
        <SText>～</SText>
        <SNumberField
          name="eigyoCdTo"
          code
          size={6}
          {...register(4)}
          dialog={<B000120 />}
          handleSubmit={(data: any) => {
            methods.setValue("eigyoCdTo", data.eigyoCd);
          }}
        />
        <SLabel gridColumn="1">受注担当部門</SLabel>
        <SNumberField
          name="bumonCdFrom"
          code
          size={6}
          {...register(5)}
          gridColumn="span 3"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdFrom", data.bumonCd);
          }}
        />
        <SText>～</SText>
        <SNumberField
          name="bumonCdTo"
          code
          size={6}
          {...register(6)}
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdTo", data.bumonCd);
          }}
        />
        <SLabel>受注担当者</SLabel>
        <SNumberField
          name="shainCdFrom"
          code
          size={7}
          {...register(18)}
          gridColumn="span 2"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdFrom", data.shainCd);
          }}
        />
        <SText>～</SText>
        <SNumberField
          name="shainCdTo"
          code
          size={7}
          {...register(19)}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdTo", data.shainCd);
          }}
        />
        <SLabel gridColumn="1">受注No</SLabel>
        <SNumberField
          name="juchudenpyoNoFrom"
          code
          size={10}
          {...register(7)}
          gridColumn="span 3"
        />
        <SText>～</SText>
        <SNumberField name="juchudenpyoNoTo" code size={10} {...register(8)} />
        <SLabel>客先No</SLabel>
        <SNumberField
          name="chumonNo"
          code
          size={11}
          {...register(20)}
          gridColumn="span 2"
        />
        <SLabel gridColumn="1">得意先</SLabel>
        <SNumberField
          name="tokuiCd"
          code
          size={6}
          {...register(9)}
          gridColumn="span 2"
          onBlur={() => B000150TokuiNm2(methods, navigate, setMsg)}
        />
        <SNumberField
          name="tokuishitenCd"
          code
          size={4}
          {...register(10)}
          onBlur={() => B000150TokuiNm2(methods, navigate, setMsg)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCd", data.tokuiCd);
            methods.setValue("tokuishitenCd", data.tokuishitenCd);
            methods.setValue("tokuiNm", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNm" size={40} disabled gridColumn="span 2" />
        <SLabel>納入先</SLabel>
        <SNumberField
          name="nonyuCd"
          code
          size={6}
          {...register(21)}
          onBlur={() => B000151NonyuNm(methods, navigate, setMsg)}
        />
        <SNumberField
          name="nonyushitenCd"
          code
          size={4}
          {...register(22)}
          onBlur={() => B000151NonyuNm(methods, navigate, setMsg)}
          dialog={<B000151 />}
          handleSubmit={(data: any) => {
            methods.setValue("nonyuCd", data.nonyuCd);
            methods.setValue("nonyushitenCd", data.nonyushitenCd);
            methods.setValue("nonyuNm", data.tokuiNmr);
          }}
        />
        <STextField name="nonyuNm" size={40} disabled gridColumn="span 2" />
        <SLabel gridColumn="1">商品分類</SLabel>
        <SNumberField
          name="shodaibun"
          code
          size={3}
          {...register(11)}
          label="商品大分類"
          required={existShochubun}
        />
        <SNumberField
          name="shochubun"
          code
          size={3}
          {...register(12)}
          label="商品中分類"
          required={existShoshobun}
        />
        <SNumberField
          name="shoshobun"
          code
          size={3}
          {...register(13)}
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            methods.setValue("shodaibun", data.shodaibun);
            methods.setValue("shochubun", data.shochubun);
            methods.setValue("shoshobun", data.shoshobun);
          }}
        />
        <SLabel gridColumn={7}>アシスタント</SLabel>
        <SNumberField
          name="assistantCd"
          code
          size={7}
          {...register(23)}
          gridColumn="span 2"
          onBlur={() => B000140AssistantNm(methods, navigate, setMsg)}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("assistantCd", data.shainCd);
            methods.setValue("assistantNm", data.shainNm);
          }}
        />
        <STextField name="assistantNm" size={40} disabled gridColumn="span 2" />
        <SLabel gridColumn="1">JANコード</SLabel>
        <SNumberField
          name="janCd"
          code
          size={13}
          {...register(14)}
          gridColumn="span 3"
          onBlur={() => B000200JanshohinNm1(methods, navigate, setMsg)}
        />
        <STextField name="janshohinNm" size={40} disabled gridColumn="span 2" />
        <SLabel gridColumn={7}>商品</SLabel>
        <SNumberField
          name="shohinCd"
          code
          size={10}
          {...register(24)}
          gridColumn="span 2"
          onBlur={() => B000200ShohinNm(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCd", data.shohinCd);
            methods.setValue("shohinNm", data.shohinNmr);
          }}
        />
        <STextField name="shohinNm" size={40} disabled gridColumn="span 2" />
        <SLabel gridColumn="1">商品種別</SLabel>
        <SCodeSelect
          label="商品種別"
          name="shohinshubetsuKbn"
          required
          {...register(15)}
          options={ShohinshubetsuKbnJuchuKakutei}
          gridColumn="span 3"
        />
        <SNormalButton
          label={labels.buttons.search}
          gridRow={9}
          gridColumn={11}
          {...register(25)}
          onClick={handleClickSearchButton}
          align="right"
        />
      </SFrame>
      <SFrame>
        <STable
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          onSelectionChange={handleCheckTableRow}
          width={1280}
          height={400}
          pageSize={500}
          multi
          onPageChange={handleResetSearch}
        />
      </SFrame>
      <SFrame gridTemplateColumns="76rem 2rem">
        <SNormalButton
          label={labels.buttons.decide}
          gridColumn={2}
          {...register(26)}
          disabled={disabledDecide}
          dialog={
            <SConfirmDialog
              title="受注確定"
              msg="選択中の受注データを確定します。よろしいですか？"
            />
          }
          dialogAction="confirm"
          handleSubmit={handleDecide}
        />
      </SFrame>
    </FormProvider>
  );
};
